import { Exporter } from 'react-admin';
import jsonExport from 'jsonexport/dist'; // yarn add jsonexport

export const couponsExporter: Exporter = (records, fetchRelatedRecords, dataProvider) => {
  const data = records.map((record: any) => {
    const participants = record?.registrant?.participants || [];

    return {
      // columns must be in the order you want in the CSV
      id: record.id,
      'Organization ID': record?.registrant?.seasonOrganization?.organization?.midasId ?? '',
      'Sent At': record?.createdAt ?? '',
      'Notification type': record.type ?? '',
      'Coupon code': record.couponCode ?? '',
      'Email Sent to': record?.registrant?.user?.email ?? '',
      Participants: participants
        .map(
          (p: { firstName: string; lastName: string; code: string }) =>
            `${p.firstName} ${p.lastName} (${p.code})`
        )
        .join(', '),
    };
  });

  jsonExport(data, { headers: Object.keys(data[0] || {}) }, (err, csv) => {
    if (err) {
      console.error(err);
      return;
    }

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'coupons.csv';
    a.click();
  });
};
